'use strict';

export const pluginPermissions = {
  displayPlugin: [{
    action: 'plugin::content-export.read',
    subject: null
  }]
};